import { gql } from '@apollo/client'
import { LOYALTY_PROGRAM_FIELDS } from './loyalty-queries'

// All nine require loyalty.manage.
//
// Every one of them returns the WHOLE programme (ladder included), so Apollo
// normalisation refreshes an open editor by itself. The LIST is re-read where
// OTHER rows change too: create, clone and delete (the set of rows), publish
// (closes the open-ended predecessor) and set end (can end a programme now).

/** A new draft. Only the name is required; the API defaults 8 · 800 · 1 · 7. */
export const CREATE_LOYALTY_PROGRAM = gql`
  ${LOYALTY_PROGRAM_FIELDS}
  mutation CreateLoyaltyProgram($input: LoyaltyProgramDraftInput!) {
    createLoyaltyProgram(input: $input) {
      ...LoyaltyProgramFields
    }
  }
`

/** Edit a DRAFT's fields. A published programme is frozen (refused server-side). */
export const UPDATE_LOYALTY_PROGRAM_DRAFT = gql`
  ${LOYALTY_PROGRAM_FIELDS}
  mutation UpdateLoyaltyProgramDraft($id: ID!, $input: LoyaltyProgramDraftInput!) {
    updateLoyaltyProgramDraft(id: $id, input: $input) {
      ...LoyaltyProgramFields
    }
  }
`

/** A new draft "<name> (kopie)" with the same fields and ladder — how rules change. */
export const CLONE_LOYALTY_PROGRAM = gql`
  ${LOYALTY_PROGRAM_FIELDS}
  mutation CloneLoyaltyProgram($id: ID!) {
    cloneLoyaltyProgram(id: $id) {
      ...LoyaltyProgramFields
    }
  }
`

/** Freeze the draft and make it the programme from `starts_at` (ISO 8601). */
export const PUBLISH_LOYALTY_PROGRAM = gql`
  ${LOYALTY_PROGRAM_FIELDS}
  mutation PublishLoyaltyProgram($id: ID!, $starts_at: String!) {
    publishLoyaltyProgram(id: $id, starts_at: $starts_at) {
      ...LoyaltyProgramFields
    }
  }
`

/** The one field a published programme may still change. */
export const RENAME_LOYALTY_PROGRAM = gql`
  ${LOYALTY_PROGRAM_FIELDS}
  mutation RenameLoyaltyProgram($id: ID!, $name: String!) {
    renameLoyaltyProgram(id: $id, name: $name) {
      ...LoyaltyProgramFields
    }
  }
`

/** Move a published programme's end. Shortening needs `confirm_close_cards`. */
export const SET_LOYALTY_PROGRAM_END = gql`
  ${LOYALTY_PROGRAM_FIELDS}
  mutation SetLoyaltyProgramEnd($id: ID!, $ends_at: String!, $confirm_close_cards: Boolean) {
    setLoyaltyProgramEnd(id: $id, ends_at: $ends_at, confirm_close_cards: $confirm_close_cards) {
      ...LoyaltyProgramFields
    }
  }
`

/** Discard a DRAFT (its tiers go with it). Returns Boolean, not the programme. */
export const DELETE_LOYALTY_PROGRAM_DRAFT = gql`
  mutation DeleteLoyaltyProgramDraft($id: ID!) {
    deleteLoyaltyProgramDraft(id: $id)
  }
`

/** Add or replace one rung of a DRAFT's ladder. `params_json` sits inside the input. */
export const UPSERT_LOYALTY_REWARD_TIER = gql`
  ${LOYALTY_PROGRAM_FIELDS}
  mutation UpsertLoyaltyRewardTier($program_id: ID!, $input: LoyaltyRewardTierInput!) {
    upsertLoyaltyRewardTier(program_id: $program_id, input: $input) {
      ...LoyaltyProgramFields
    }
  }
`

/** Remove one rung of a DRAFT's ladder. */
export const DELETE_LOYALTY_REWARD_TIER = gql`
  ${LOYALTY_PROGRAM_FIELDS}
  mutation DeleteLoyaltyRewardTier($id: ID!) {
    deleteLoyaltyRewardTier(id: $id) {
      ...LoyaltyProgramFields
    }
  }
`
